import { render, staticRenderFns } from "./PlayersOverview.vue?vue&type=template&id=83099e54&"
import script from "./PlayersOverview.vue?vue&type=script&lang=ts&"
export * from "./PlayersOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports